/**
 * @generated SignedSource<<73f9bd90adbedf4d1348e3ee9a41d002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type AssociatedPriceRulesInput = {
  channel?: CartChannel | null;
  groupId?: string | null;
  participatingOffers?: string | null;
  targetOfferId: string;
};
export type PaymentOptionsAssociatedPriceRulesQuery$variables = {
  input: AssociatedPriceRulesInput;
};
export type PaymentOptionsAssociatedPriceRulesQuery$data = {
  readonly priceRulesData: {
    readonly priceRules: ReadonlyArray<{
      readonly description: string;
      readonly basePrice: number | null;
      readonly basePriceExcludingTax: number | null;
      readonly effectivePrice: number | null;
      readonly effectivePriceExcludingTax: number | null;
      readonly priceFrequencyPeriod: string | null;
      readonly priceFrequencyValue: number | null;
      readonly priceLength: number | null;
      readonly priceType: string;
      readonly downPaymentRequired: boolean | null;
      readonly minimumDownPaymentAmount: number | null;
      readonly sources: ReadonlyArray<{
        readonly sourceId: string;
      }>;
    }>;
  };
};
export type PaymentOptionsAssociatedPriceRulesQuery = {
  variables: PaymentOptionsAssociatedPriceRulesQuery$variables;
  response: PaymentOptionsAssociatedPriceRulesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "priceRulesData",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssociatedPriceRulesResponse",
    "kind": "LinkedField",
    "name": "priceRulesByTargetOfferId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductVariantAssociatedPriceRule",
        "kind": "LinkedField",
        "name": "priceRules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "basePrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "basePriceExcludingTax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectivePrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectivePriceExcludingTax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceFrequencyPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceFrequencyValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceLength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downPaymentRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumDownPaymentAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductVariantOfferDetail",
            "kind": "LinkedField",
            "name": "sources",
            "plural": true,
            "selections": [
              {
                "alias": "sourceId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentOptionsAssociatedPriceRulesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentOptionsAssociatedPriceRulesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac1015f62038266bb1f0d41962e52a16",
    "id": null,
    "metadata": {},
    "name": "PaymentOptionsAssociatedPriceRulesQuery",
    "operationKind": "query",
    "text": "query PaymentOptionsAssociatedPriceRulesQuery(\n  $input: AssociatedPriceRulesInput!\n) {\n  priceRulesData: priceRulesByTargetOfferId(input: $input) {\n    priceRules {\n      description\n      basePrice\n      basePriceExcludingTax\n      effectivePrice\n      effectivePriceExcludingTax\n      priceFrequencyPeriod\n      priceFrequencyValue\n      priceLength\n      priceType\n      downPaymentRequired\n      minimumDownPaymentAmount\n      sources {\n        sourceId: id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7ac586a168e706dda39c4f382034fbd";

export default node;
